import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from 'split-type';

gsap.registerPlugin(ScrollTrigger) 

export const animation = () => {
  bannerAnimation();
  fadeupAnimation();
  fadeinAnimation();
  staggerCardAnimation();
  staggerFaqAnimation();
  logosAnimation();
  logosAnimationDesktop();
  animateHeroCardsOnMouseMove();
  waveAnimation();
  ctaAnimation();
  step2Animation();
  step3Animation();
  newsletterAnimation();
  pinCardAnimation();
  numberCounterAnimation();
  scaleDownAnimation();
  tempLoading();
  footerAnimation();
}

const easeDefault = "circ.out";
const easeCard = "elastic.out(1, 0.75)"
const tabletSize = 768;
const mobileSize = 575;

const bannerAnimation = () => {
    const bannerDelay = 0.5;

    gsap.to('.navbar', { 
      opacity: 1,
      duration: 0.5,
      delay: bannerDelay + 0.1,
      ease: easeDefault,
    })

    gsap.from('.hero-text h1', { 
      y: 100,
      duration: 0.5,
      delay: bannerDelay,
      ease: easeDefault
    })

    gsap.fromTo('.hero-text .lead', {
      y: 220,
      opacity: 0,
    },{
      y: 0,
      opacity: 1,
      duration: 0.55,
      delay: bannerDelay,
      ease: easeDefault
    })
  
    gsap.to('.blob-shape-left', {
      opacity: 1,
      duration: 0.5,
      ease: easeDefault,
      delay: bannerDelay,
    })

    gsap.fromTo('.get-started', {
      y: 200,
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      scale: 1,
      duration: 0.55,
      delay: bannerDelay,
      ease: easeDefault,
      onComplete: () => {
        gsap.fromTo('.fadeup-after-banner', {
          opacity: 0,
          y: 50,
        }, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          delay: 0.5,
          ease: easeDefault,
          scrollTrigger: '.fadeup-after-banner',
        })

        gsap.fromTo('.fadein-after-banner', {
          opacity: 0,
        }, {
          opacity: 1,
          duration: 0.6,
          delay: 0.5,
          ease: easeDefault,
          scrollTrigger: '.fadein-after-banner',
        })
      }
    })

    let card_stagger = 0.05
    let card_init_delay = bannerDelay + 0.15 
    let card_duration = 2

    gsap.fromTo('.hero-card-1', {
      opacity: 0,
      scale: 0.7,
      y: 30,
      x: 150,
    },{
      opacity: 1,
      scale: 1,
      y: 0,
      x: 0,
      duration: card_duration,
      delay: card_init_delay,
      ease: easeCard
    })

    gsap.fromTo('.hero-card-2', {
      opacity: 0,
      scale: 0.7,
      y: 0,
      x: -250,
    },{
      opacity: 1,
      scale: 1,
      y: 0,
      x: 0,
      duration: card_duration,
      delay: card_init_delay + card_stagger * 1,
      ease: easeCard
    })

    gsap.fromTo('.hero-card-3', {
      opacity: 0,
      scale: 0.7,
      y: 0,
      x: 250,
    },{
      opacity: 1,
      scale: 1,
      y: 0,
      x: 0,
      duration: card_duration,
      delay:  card_init_delay + card_stagger * 2,
      ease: easeCard
    })

    gsap.fromTo('.hero-card-4', {
      opacity: 0,
      scale: 0.7,
      y: 0,
      x: -250,
    },{
      opacity: 1,
      scale: 1,
      y: 0,
      x: 0,
      duration: card_duration,
      delay:  card_init_delay + card_stagger * 3,
      ease: easeCard,
    })
}

const logosAnimationDesktop = () => {
  let currentPosition = 0;
  const logo_top_container = document.querySelector('.logo-container-lg');
  const original_logos = logo_top_container.querySelector('.logos');
  const cloned_logos_first = original_logos.cloneNode(true);
  const cloned_logos_second = original_logos.cloneNode(true);
  logo_top_container.appendChild(cloned_logos_first);
  logo_top_container.appendChild(cloned_logos_second);

  const logosList = [original_logos, cloned_logos_first, cloned_logos_second];
  const logosWidth = 1183;

  const moveLogos = () => {
    currentPosition -= 1; 
    logosList.forEach(logos => {
      if (Math.abs(currentPosition) >= logosWidth) {
        currentPosition = 0;
      }
      logos.style.transform = `translateX(${currentPosition}px)`;
    })

    requestAnimationFrame(moveLogos);
  }

  moveLogos();
}

const logosAnimation = () => {
  const logo_top_container = document.querySelector('.top-container');
  const original_top_logos = logo_top_container.querySelector('.logos');
  const cloned_top_logos_first = original_top_logos.cloneNode(true);
  const cloned_top_logos_second = original_top_logos.cloneNode(true);
  logo_top_container.appendChild(cloned_top_logos_first);
  logo_top_container.appendChild(cloned_top_logos_second);

  const topLogosList = [original_top_logos, cloned_top_logos_first, cloned_top_logos_second];
  const topLogosWidth = 708;
  let topCurrentPosition = -topLogosWidth;

  const logo_bottom_container = document.querySelector('.bottom-container');
  const original_bottom_logos = logo_bottom_container.querySelector('.logos');
  const cloned_bottom_logos_first = original_bottom_logos.cloneNode(true);
  const cloned_bottom_logos_second = original_bottom_logos.cloneNode(true);
  logo_bottom_container.appendChild(cloned_bottom_logos_first);
  logo_bottom_container.appendChild(cloned_bottom_logos_second);

  const bottomLogosList = [original_bottom_logos, cloned_bottom_logos_first, cloned_bottom_logos_second];
  const bottomLogosWidth = 729;
  let bottomCurrentPosition = -bottomLogosWidth;

  const moveLogos = () => {
    topCurrentPosition += 1; 
    bottomCurrentPosition -= 1; 

    topLogosList.forEach(logos => {
      if (topCurrentPosition >= 0) {
        topCurrentPosition = -topLogosWidth;
      }
      logos.style.transform = `translateX(${topCurrentPosition}px)`;
    })

    bottomLogosList.forEach(logos => {
      if (Math.abs(bottomCurrentPosition) >= bottomLogosWidth) {
        bottomCurrentPosition = 0;
      }
      logos.style.transform = `translateX(${bottomCurrentPosition}px)`;
    })

    requestAnimationFrame(moveLogos);
  }

  moveLogos();
}

const animateHeroCardsOnMouseMove = () => {
  const hero_cards = document.querySelectorAll('.hero-card');
  let prevX = 0;
  let prevY = 0;
  let moveX = 0;
  let moveY = 0;
  let deltaX, deltaY;

  const speed_offset = 0.005;

  window.onmousemove = (event) => {
    if(prevX === 0 && prevY === 0) {
      prevX = event.clientX;
      prevY = event.clientY;
    } else {
      deltaX = event.clientX - prevX;
      deltaY = event.clientY - prevY;
    }

    deltaX = event.clientX - prevX;
    deltaY = event.clientY - prevY;

    moveX += deltaX;
    moveY += deltaY;

    prevX = event.clientX;
    prevY = event.clientY;

    hero_cards.forEach( (card, index) => {
      card.style.transform = `translate(${ moveX * speed_offset * (index + 1) }px, ${ moveY * speed_offset * (index + 1) }px)` 
    })
  }
}

const waveAnimation = () => {
  let type_split = new SplitType('.split-text', {
    types: 'chars',
    tagName: 'div'
  })
  
  const wave_headings = document.querySelectorAll('.wave-heading');
  wave_headings.forEach(heading => {
    gsap.from(heading.querySelectorAll('.char'), {
      y: '100%',
      opacity: 1,
      duration: 0.3,
      ease: 'power1.out',
      stagger: 0.03,
      scrollTrigger: heading, 
    })

    gsap.from(heading.querySelector('.line'), {
      scaleX: 0,
      transformOrigin: 'left center',
      duration: 1,
      delay: 0.5,
      scrollTrigger: heading,
    })
  })
};

const fadeinAnimation = () => {
  const fadeins = document.querySelectorAll('.scroll-trigger-fadein')
  fadeins.forEach(element => {
    gsap.from(element, {
      opacity: 0,
      duration: 0.6,
      scrollTrigger: element,
      delay: 0.2
    })
  })
}

const fadeupAnimation = () => {
  const fadeup_elements = document.querySelectorAll('.scroll-trigger-fadeup');
  const fadeup_delay_elements = document.querySelectorAll('.scroll-trigger-fadeup-delay');
  fadeup_elements.forEach(element => {
    gsap.fromTo(element, {
      opacity: 0,
      y: 50,
    }, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      delay: 0.2,
      ease: easeDefault,
      scrollTrigger: element,
    })
  })

  fadeup_delay_elements.forEach(element => {
    gsap.fromTo(element, {
      opacity: 0,
      y: 50,
    }, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      delay: 0.5,
      ease: easeDefault,
      scrollTrigger: element,
    })
  })
}

const staggerCardAnimation = () => {
  const card_containers = document.querySelectorAll('.stagger-fadeup-card-container')
  card_containers.forEach(card_container => {
    const cards = card_container.querySelectorAll(".card");
    gsap.from(cards, {
      y: 30,
      opacity: 0,
      ease: easeDefault, 
      duration: 0.6, 
      stagger: 0.2, 
      delay: 0.3,
      scrollTrigger: {
        trigger: card_container,
        start: "top bottom-=100",
      },
    });
  })
}


const ctaAnimation = () => {
  if (window.innerWidth <= mobileSize) {
    return;
  }
  
  const cta_container = document.querySelector('.cta-container');
  let cta_scroll = -2000;
  let prev_scroll_pos = window.scrollY;
  let speed = 1.5;
  
  if (cta_container)
    cta_container.style.transform = `translateX(${cta_scroll * speed}px)`;

  window.onscroll = (event) => {
    const current_scroll_pos = window.scrollY;
    if (prev_scroll_pos > current_scroll_pos) {
      cta_scroll--;
    } else if (prev_scroll_pos < current_scroll_pos) {
      cta_scroll++;
    }
    if (cta_scroll >= 0) {
      cta_scroll = 0;
    }
    prev_scroll_pos = current_scroll_pos;
    cta_container.style.transform = `translateX(${cta_scroll * speed}px)`
  }
}

const pinCardAnimation = () => {
  const pin_cards = document.querySelectorAll('.pin-card');
  const spacer = 20;

  gsap.from('.pin-card-container', {
    opacity: 0,
    duration: 0.3,
    delay: 0.3,
    scrollTrigger: '.pin-card-container',
    onComplete: () => {
      const highlight_border = document.getElementById('highlight-border');
      const highlight_border_md = document.getElementById('highlight-border-md');
      highlight_border.classList.add('highlight-border-animation');
      highlight_border_md.classList.add('highlight-border-animation-md');

      const circle = document.querySelector('.check-spinner__circle');
      const worm_a = document.querySelector('.check-spinner__worm-a');
      const worm_b = document.querySelector('.check-spinner__worm-b');

      circle.classList.add('circle_animation');
      worm_a.classList.add('worm-a_animation');
      worm_b.classList.add('worm-b_animation');
    }
  })

  if (window.innerWidth < tabletSize) {
    return;
  }

  pin_cards.forEach((card, index) => {
    const desktop_start = `top-=${index * spacer + index * 10} top+=140px`;
    const desktop_end = `bottom top+=${750 + (pin_cards.length * spacer)}`;

    const mobile_start = `top-=${index * spacer + index * 10} top+=100px`;
    const mobile_end = `bottom top+=${750 + (pin_cards.length * spacer)}`;

    ScrollTrigger.create({
      trigger: card,
      endTrigger: '.step-3',
      start: window.innerWidth >= tabletSize ? desktop_start : mobile_start,
      end: window.innerWidth >= tabletSize ? desktop_end : mobile_end,
      pin: true,
      pinSpacing: false,
      id: 'card-pin',
      invalidateOnRefresh: true,
    });
  });
}

const numberCounterAnimation = () => {
  let counters = document.querySelectorAll('.counter-animation')
  counters.forEach(counter => {
    let value = {
      val: parseInt(counter.innerText)
    };
    const remaining_element = counter.innerHTML.replace(parseInt(counter.innerText), "");

    gsap.from(value, {
      duration: 1,
      ease: easeDefault,
      val: 0,
      roundProps: 'val',
      delay: 0.6,
      onUpdate: function() {
        counter.innerHTML = value.val + remaining_element;
      },
      scrollTrigger: counter,
    })
  })
}

const scaleDownAnimation = () => {
  const elements = document.querySelectorAll('.scroll-trigger-scale-down');
  elements.forEach(element => {
    gsap.from(element, {
      scrollTrigger: element, 
      transformOrigin: "top center",
      scale: 1.5,
      duration: 0.5,
      delay:0.0,
      ease: easeDefault
    })
  })
}

const step2Animation = () => {
  const animation_start_point = 'top 70%';
  const animation_end_point = 'top+=120px 40%';
  gsap.from('.parallax-person', {
    scale: 1.3,
    scrollTrigger: {
      trigger: '.parallax-person',
      start: animation_start_point, 
      end: animation_end_point,
      scrub: true,
    }
  });

  gsap.from('.parallax-highlighter', {
    x: 400,
    scrollTrigger: {
      trigger: '.parallax-highlighter',
      start: animation_start_point, 
      end: animation_end_point,
      scrub: true,
    }
  });

  gsap.from('.parallax-text', {
    x: 400,
    scrollTrigger: {
      trigger: '.parallax-text',
      start: animation_start_point, 
      end: animation_end_point,
      scrub: true,
    }
  });
}

const step3Animation = () => {
  const animation_start_point = 'top 80%';
  const animation_end_point = 'top+=120px 50%';
  const offsetAmount = window.innerWidth <= tabletSize ? 150 : 130;
  const personOffset = window.innerWidth <= tabletSize ? 300 : 250
  gsap.from('#content-block', {
    y: `${offsetAmount}px` ,
    scrollTrigger: {
      trigger: '#content-block',
      start: animation_start_point, 
      end: animation_end_point,
      scrub: true,
    }
  });

  gsap.from('.step-3-person', {
    y:  `${offsetAmount + personOffset}px`,
    scrollTrigger: {
      trigger: '#content-block',
      start: animation_start_point,
      end: animation_end_point,
      scrub: true,
    }
  });
}

const newsletterAnimation = () => {
  const animation_start_point = window.innerWidth > mobileSize ? 'top+=60px 90%' : 'top-=260px 90%';
  const animation_end_point = window.innerWidth > mobileSize ? 'top+=140px 70%' : 'top-=200px 70%';

  gsap.from('.parallax-blob-right', {
    y: "200px",
    scrollTrigger: {
      trigger: '.parallax-blob-right',
      start: animation_start_point,
      end: animation_end_point,
      scrub: true,
    }
  });

  gsap.from('.glow', {
    width: 0,
    height: 0,
    x: "-100px",
    y: "30px",
    transformOrigin: "top left",
    scrollTrigger: {
      trigger: '.parallax-blob-right',
      start: window.innerWidth > mobileSize ? 'top+=250px 90%' : 'top-=150px 90%',
      end: window.innerWidth > mobileSize ? 'top+=280px 80%' : 'top-=100px 70%',
      scrub: true,
    }
  })

  gsap.from('.parallax-blob-left', {
    y: -200,
    scrollTrigger: {
      trigger: '.parallax-blob-right',
      start: animation_start_point,
      end: animation_end_point, 
      scrub: true,
    }
  });
}

const staggerFaqAnimation = () => {
  const card_containers = document.querySelectorAll('.stagger-fadeup-faq-container')
  card_containers.forEach(card_container => {
    const cards = card_container.querySelectorAll(".accordion-item");
    gsap.from(cards, {
      duration: 0.6, 
      y: 30,
      opacity: 0,
      ease: easeDefault, 
      stagger: 0.2, 
      delay: 0.2,
      scrollTrigger: {
        trigger: card_container,
        start: "top bottom-=100",
      },
    });
  })
}

const footerAnimation = () => {
  if (window.innerWidth <= mobileSize) {
    return;
  }
  gsap.to('.footer-animation', {
    width: '100%',
    scrollTrigger: {
      trigger: '.footer-animation',
      start: 'top 80%',
      end: 'top+=320px 50%',
      scrub: true,
    }
  })

  const stagger_footer_items = document.querySelectorAll(".stagger-footer");
  gsap.from(stagger_footer_items, {
    y: 30,
    opacity: 0,
    ease: easeDefault, 
    duration: 0.3, 
    stagger: 0.2, 
    delay: 0.4,
    scrollTrigger: {
      trigger: '.footer-container',
      start: "top bottom-=30",
    },
  });
}

const tempLoading = () => {
  const modal = document.getElementById('modal-subscribe');
  const animation_container = document.querySelector('.loading-animation-container');

  if (window.innerWidth <= mobileSize) {
    const blob_animation_container = document.querySelector('.modal-blob-animation');
    const blob = blob_animation_container.querySelector('.blob');
    blob.setAttribute('width', 240);
  }

  //@TODO update loading animation here to reflect actual loading time
  modal.addEventListener('shown.bs.modal', () => {
    setTimeout(()=> {
      gsap.to(animation_container, {
        opacity: 0,
        duration: 0.5,
        onComplete: () => {
          animation_container.style.display = 'none'
        }
      })
    }, 4000)
  });

  modal.addEventListener('hide.bs.modal', () => {
    animation_container.style.display = 'block'
    animation_container.style.opacity = 1 
  });
}
